import { render } from "./PanelFooter.vue?vue&type=template&id=c7ec38f6&scoped=true"
import script from "./PanelFooter.vue?vue&type=script&lang=js"
export * from "./PanelFooter.vue?vue&type=script&lang=js"

import "./PanelFooter.vue?vue&type=style&index=0&id=c7ec38f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7ec38f6"]])

export default __exports__